import React from "react";
import ReactDOM from "react-dom";
import "./styles/styles.scss";
import "./i18n";
import App from "./app.component";
import * as serviceWorker from "./serviceWorker";
import { setupInterceptors } from "./interceptors/auth-intercept";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

setupInterceptors();

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
